import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { insightsAPI } from '../../services/api';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import Toast from '../../components/common/Toast';

const InsightList = () => {
  const [insights, setInsights] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

  useEffect(() => {
    fetchInsights();
  }, []);

  const fetchInsights = async () => {
    setLoading(true);
    try {
      const response = await insightsAPI.getAll({ status: 'all' });
      if (response.data.success) setInsights(response.data.data.insights);
    } catch (error) {
      setToast({ show: true, message: 'Failed to fetch insights', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this insight?')) return;
    try {
      await insightsAPI.delete(id);
      setToast({ show: true, message: 'Insight deleted', type: 'success' });
      fetchInsights();
    } catch (error) {
      setToast({ show: true, message: 'Failed to delete', type: 'error' });
    }
  };

  return (
    <div>
      <Toast show={toast.show} message={toast.message} type={toast.type} onClose={() => setToast({ ...toast, show: false })} />
      <div className="page-header mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h2 className="page-title">Daily Insights</h2>
            <p className="page-subtitle">Manage daily inspiration content</p>
          </div>
          <Link to="/insights/new" className="btn btn-primary"><i className="bi bi-plus-circle me-2"></i>New Insight</Link>
        </div>
      </div>

      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="data-table">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr><th>Title</th><th>Category</th><th>Order</th><th>Status</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {insights.map((insight) => (
                  <tr key={insight.id}>
                    <td>{insight.title}</td>
                    <td><span className="badge badge-purple">{insight.category_id}</span></td>
                    <td>{insight.display_order}</td>
                    <td>{insight.is_active ? <span className="badge badge-success">Active</span> : <span className="badge badge-danger">Inactive</span>}</td>
                    <td>
                      <div className="action-buttons">
                        <Link to={`/insights/edit/${insight.id}`} className="btn btn-sm btn-outline-primary"><i className="bi bi-pencil"></i></Link>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(insight.id)}><i className="bi bi-trash"></i></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default InsightList;